export const color = {
    "avatar": {
        "background": {
            "image": {
                "default": "var(--colorAvatarBackgroundImageDefault)",
                "hover": "var(--colorAvatarBackgroundImageHover)"
            },
            "project": {
                "default": "var(--colorAvatarBackgroundProjectDefault)",
                "hover": "var(--colorAvatarBackgroundProjectHover)"
            },
            "space": {
                "default": "var(--colorAvatarBackgroundSpaceDefault)",
                "hover": "var(--colorAvatarBackgroundSpaceHover)"
            },
            "template": {
                "default": "var(--colorAvatarBackgroundTemplateDefault)",
                "hover": "var(--colorAvatarBackgroundTemplateHover)"
            },
            "tenant": {
                "default": "var(--colorAvatarBackgroundTenantDefault)",
                "hover": "var(--colorAvatarBackgroundTenantHover)"
            },
            "user": {
                "default": "var(--colorAvatarBackgroundUserDefault)",
                "hover": "var(--colorAvatarBackgroundUserHover)"
            }
        },
        "icon": {
            "primary": "var(--colorAvatarIconPrimary)",
            "secondary": "var(--colorAvatarIconSecondary)"
        },
        "text": "var(--colorAvatarText)"
    },
    "avatarStack": {
        "background": {
            "hover": "var(--colorAvatarStackBackgroundHover)"
        },
        "border": "var(--colorAvatarStackBorder)"
    },
    "background": {
        "bold": "var(--colorBackgroundBold)",
        "danger": "var(--colorBackgroundDanger)",
        "disabled": "var(--colorBackgroundDisabled)",
        "feature": "var(--colorBackgroundFeature)",
        "info": "var(--colorBackgroundInfo)",
        "inverse": {
            "neutral": "var(--colorBackgroundInverseNeutral)",
            "primary": "var(--colorBackgroundInversePrimary)",
            "secondary": "var(--colorBackgroundInverseSecondary)",
            "success": "var(--colorBackgroundInverseSuccess)"
        },
        "primary": {
            "default": "var(--colorBackgroundPrimaryDefault)",
            "hover": "var(--colorBackgroundPrimaryHover)",
            "pressed": "var(--colorBackgroundPrimaryPressed)",
            "transparent": "var(--colorBackgroundPrimaryTransparent)"
        },
        "quartary": {
            "default": "var(--colorBackgroundQuartaryDefault)",
            "hover": "var(--colorBackgroundQuartaryHover)",
            "pressed": "var(--colorBackgroundQuartaryPressed)"
        },
        "secondary": {
            "default": "var(--colorBackgroundSecondaryDefault)",
            "hover": "var(--colorBackgroundSecondaryHover)",
            "pressed": "var(--colorBackgroundSecondaryPressed)",
            "transparent": "var(--colorBackgroundSecondaryTransparent)"
        },
        "selected": "var(--colorBackgroundSelected)",
        "success": "var(--colorBackgroundSuccess)",
        "tertiary": "var(--colorBackgroundTertiary)",
        "warning": "var(--colorBackgroundWarning)"
    },
    "badge": {
        "bold": {
            "background": {
                "danger": "var(--colorBadgeBoldBackgroundDanger)",
                "feature": "var(--colorBadgeBoldBackgroundFeature)",
                "info": "var(--colorBadgeBoldBackgroundInfo)",
                "inverseNeutral": "var(--colorBadgeBoldBackgroundInverseNeutral)",
                "neutral": "var(--colorBadgeBoldBackgroundNeutral)",
                "success": "var(--colorBadgeBoldBackgroundSuccess)",
                "upsell": "var(--colorBadgeBoldBackgroundUpsell)",
                "warning": "var(--colorBadgeBoldBackgroundWarning)"
            },
            "icon": {
                "feature": "var(--colorBadgeBoldIconFeature)",
                "primary": "var(--colorBadgeBoldIconPrimary)",
                "secondary": "var(--colorBadgeBoldIconSecondary)",
                "upsell": "var(--colorBadgeBoldIconUpsell)"
            },
            "text": {
                "feature": "var(--colorBadgeBoldTextFeature)",
                "primary": "var(--colorBadgeBoldTextPrimary)",
                "secondary": "var(--colorBadgeBoldTextSecondary)",
                "upsell": "var(--colorBadgeBoldTextUpsell)"
            }
        },
        "subtle": {
            "background": {
                "danger": "var(--colorBadgeSubtleBackgroundDanger)",
                "feature": "var(--colorBadgeSubtleBackgroundFeature)",
                "info": "var(--colorBadgeSubtleBackgroundInfo)",
                "neutral": "var(--colorBadgeSubtleBackgroundNeutral)",
                "success": "var(--colorBadgeSubtleBackgroundSuccess)",
                "upsell": "var(--colorBadgeSubtleBackgroundUpsell)",
                "warning": "var(--colorBadgeSubtleBackgroundWarning)"
            },
            "border": {
                "danger": "var(--colorBadgeSubtleBorderDanger)",
                "feature": "var(--colorBadgeSubtleBorderFeature)",
                "info": "var(--colorBadgeSubtleBorderInfo)",
                "neutral": "var(--colorBadgeSubtleBorderNeutral)",
                "success": "var(--colorBadgeSubtleBorderSuccess)",
                "upsell": "var(--colorBadgeSubtleBorderUpsell)",
                "warning": "var(--colorBadgeSubtleBorderWarning)"
            },
            "icon": {
                "danger": "var(--colorBadgeSubtleIconDanger)",
                "feature": "var(--colorBadgeSubtleIconFeature)",
                "info": "var(--colorBadgeSubtleIconInfo)",
                "neutral": "var(--colorBadgeSubtleIconNeutral)",
                "success": "var(--colorBadgeSubtleIconSuccess)",
                "upsell": "var(--colorBadgeSubtleIconUpsell)",
                "warning": "var(--colorBadgeSubtleIconWarning)"
            },
            "text": {
                "danger": "var(--colorBadgeSubtleTextDanger)",
                "feature": "var(--colorBadgeSubtleTextFeature)",
                "info": "var(--colorBadgeSubtleTextInfo)",
                "neutral": "var(--colorBadgeSubtleTextNeutral)",
                "success": "var(--colorBadgeSubtleTextSuccess)",
                "upsell": "var(--colorBadgeSubtleTextUpsell)",
                "warning": "var(--colorBadgeSubtleTextWarning)"
            }
        }
    },
    "border": {
        "bold": "var(--colorBorderBold)",
        "danger": "var(--colorBorderDanger)",
        "default": "var(--colorBorderDefault)",
        "disabled": "var(--colorBorderDisabled)",
        "feature": "var(--colorBorderFeature)",
        "info": "var(--colorBorderInfo)",
        "inverse": {
            "primary": "var(--colorBorderInversePrimary)",
            "secondary": "var(--colorBorderInverseSecondary)"
        },
        "link": {
            "default": "var(--colorBorderLinkDefault)",
            "hover": "var(--colorBorderLinkHover)"
        },
        "primary": "var(--colorBorderPrimary)",
        "secondary": "var(--colorBorderSecondary)",
        "selected": "var(--colorBorderSelected)",
        "success": "var(--colorBorderSuccess)",
        "tertiary": "var(--colorBorderTertiary)",
        "warning": "var(--colorBorderWarning)"
    },
    "button": {
        "background": {
            "destructive": {
                "default": "var(--colorButtonBackgroundDestructiveDefault)",
                "hover": "var(--colorButtonBackgroundDestructiveHover)",
                "pressed": "var(--colorButtonBackgroundDestructivePressed)"
            },
            "disabled": "var(--colorButtonBackgroundDisabled)",
            "loud": {
                "default": "var(--colorButtonBackgroundLoudDefault)",
                "hover": "var(--colorButtonBackgroundLoudHover)",
                "pressed": "var(--colorButtonBackgroundLoudPressed)"
            },
            "neutral": {
                "default": "var(--colorButtonBackgroundNeutralDefault)",
                "hover": "var(--colorButtonBackgroundNeutralHover)",
                "pressed": "var(--colorButtonBackgroundNeutralPressed)"
            },
            "primary": {
                "default": "var(--colorButtonBackgroundPrimaryDefault)",
                "hover": "var(--colorButtonBackgroundPrimaryHover)",
                "pressed": "var(--colorButtonBackgroundPrimaryPressed)"
            },
            "quiet": {
                "default": "var(--colorButtonBackgroundQuietDefault)",
                "hover": "var(--colorButtonBackgroundQuietHover)",
                "pressed": "var(--colorButtonBackgroundQuietPressed)"
            },
            "secondary": {
                "default": "var(--colorButtonBackgroundSecondaryDefault)",
                "hover": "var(--colorButtonBackgroundSecondaryHover)",
                "pressed": "var(--colorButtonBackgroundSecondaryPressed)"
            },
            "tertiary": {
                "default": "var(--colorButtonBackgroundTertiaryDefault)",
                "hover": "var(--colorButtonBackgroundTertiaryHover)",
                "pressed": "var(--colorButtonBackgroundTertiaryPressed)"
            }
        },
        "border": {
            "disabled": "var(--colorButtonBorderDisabled)",
            "secondary": "var(--colorButtonBorderSecondary)"
        },
        "icon": {
            "destructive": "var(--colorButtonIconDestructive)",
            "disabled": "var(--colorButtonIconDisabled)",
            "loud": "var(--colorButtonIconLoud)",
            "neutral": "var(--colorButtonIconNeutral)",
            "primary": "var(--colorButtonIconPrimary)",
            "quiet": "var(--colorButtonIconQuiet)",
            "secondary": "var(--colorButtonIconSecondary)",
            "tertiary": "var(--colorButtonIconTertiary)"
        },
        "text": {
            "destructive": "var(--colorButtonTextDestructive)",
            "disabled": "var(--colorButtonTextDisabled)",
            "loud": "var(--colorButtonTextLoud)",
            "neutral": "var(--colorButtonTextNeutral)",
            "primary": "var(--colorButtonTextPrimary)",
            "quiet": "var(--colorButtonTextQuiet)",
            "secondary": "var(--colorButtonTextSecondary)",
            "tertiary": "var(--colorButtonTextTertiary)"
        }
    },
    "callout": {
        "background": {
            "danger": {
                "default": "var(--colorCalloutBackgroundDangerDefault)",
                "hover": "var(--colorCalloutBackgroundDangerHover)",
                "pressed": "var(--colorCalloutBackgroundDangerPressed)"
            },
            "feature": {
                "default": "var(--colorCalloutBackgroundFeatureDefault)",
                "hover": "var(--colorCalloutBackgroundFeatureHover)",
                "pressed": "var(--colorCalloutBackgroundFeaturePressed)"
            },
            "info": {
                "default": "var(--colorCalloutBackgroundInfoDefault)",
                "hover": "var(--colorCalloutBackgroundInfoHover)",
                "pressed": "var(--colorCalloutBackgroundInfoPressed)"
            },
            "success": {
                "default": "var(--colorCalloutBackgroundSuccessDefault)",
                "hover": "var(--colorCalloutBackgroundSuccessHover)",
                "pressed": "var(--colorCalloutBackgroundSuccessPressed)"
            },
            "upsell": "var(--colorCalloutBackgroundUpsell)",
            "warning": {
                "default": "var(--colorCalloutBackgroundWarningDefault)",
                "hover": "var(--colorCalloutBackgroundWarningHover)",
                "pressed": "var(--colorCalloutBackgroundWarningPressed)"
            }
        },
        "border": {
            "danger": "var(--colorCalloutBorderDanger)",
            "default": "var(--colorCalloutBorderDefault)",
            "feature": "var(--colorCalloutBorderFeature)",
            "info": "var(--colorCalloutBorderInfo)",
            "success": "var(--colorCalloutBorderSuccess)",
            "upsell": "var(--colorCalloutBorderUpsell)",
            "warning": "var(--colorCalloutBorderWarning)"
        },
        "code": {
            "background": "var(--colorCalloutCodeBackground)"
        },
        "icon": {
            "danger": "var(--colorCalloutIconDanger)",
            "feature": "var(--colorCalloutIconFeature)",
            "info": "var(--colorCalloutIconInfo)",
            "success": "var(--colorCalloutIconSuccess)",
            "warning": "var(--colorCalloutIconWarning)"
        },
        "text": {
            "body": "var(--colorCalloutTextBody)",
            "danger": "var(--colorCalloutTextDanger)",
            "feature": "var(--colorCalloutTextFeature)",
            "info": "var(--colorCalloutTextInfo)",
            "success": "var(--colorCalloutTextSuccess)",
            "warning": "var(--colorCalloutTextWarning)"
        }
    },
    "card": {
        "background": {
            "primary": {
                "default": "var(--colorCardBackgroundPrimaryDefault)"
            },
            "secondary": {
                "default": "var(--colorCardBackgroundSecondaryDefault)",
                "hover": "var(--colorCardBackgroundSecondaryHover)"
            }
        },
        "chart": {
            "background": {
                "default": "var(--colorCardChartBackgroundDefault)",
                "hover": "var(--colorCardChartBackgroundHover)"
            }
        }
    },
    "carousel": {
        "background": {
            "primary": "var(--colorCarouselBackgroundPrimary)"
        },
        "icon": {
            "default": "var(--colorCarouselIconDefault)",
            "hover": "var(--colorCarouselIconHover)",
            "selected": "var(--colorCarouselIconSelected)"
        },
        "text": {
            "primary": "var(--colorCarouselTextPrimary)"
        }
    },
    "categorySelectList": {
        "background": {
            "active": "var(--colorCategorySelectListBackgroundActive)",
            "default": "var(--colorCategorySelectListBackgroundDefault)",
            "hover": "var(--colorCategorySelectListBackgroundHover)"
        },
        "icon": {
            "active": "var(--colorCategorySelectListIconActive)",
            "default": "var(--colorCategorySelectListIconDefault)",
            "hover": "var(--colorCategorySelectListIconHover)"
        },
        "text": {
            "active": "var(--colorCategorySelectListTextActive)",
            "hover": "var(--colorCategorySelectListTextHover)"
        }
    },
    "chip": {
        "background": {
            "danger": "var(--colorChipBackgroundDanger)",
            "primary": "var(--colorChipBackgroundPrimary)",
            "secondary": "var(--colorChipBackgroundSecondary)",
            "successful": "var(--colorChipBackgroundSuccessful)"
        },
        "border": {
            "primary": "var(--colorChipBorderPrimary)"
        },
        "filled": {
            "background": {
                "danger": "var(--colorChipFilledBackgroundDanger)",
                "info": "var(--colorChipFilledBackgroundInfo)",
                "primary": "var(--colorChipFilledBackgroundPrimary)",
                "secondary": "var(--colorChipFilledBackgroundSecondary)",
                "success": "var(--colorChipFilledBackgroundSuccess)",
                "warning": "var(--colorChipFilledBackgroundWarning)"
            },
            "icon": {
                "danger": "var(--colorChipFilledIconDanger)",
                "info": "var(--colorChipFilledIconInfo)",
                "primary": "var(--colorChipFilledIconPrimary)",
                "secondary": "var(--colorChipFilledIconSecondary)",
                "success": "var(--colorChipFilledIconSuccess)",
                "warning": "var(--colorChipFilledIconWarning)"
            },
            "text": {
                "danger": "var(--colorChipFilledTextDanger)",
                "info": "var(--colorChipFilledTextInfo)",
                "primary": "var(--colorChipFilledTextPrimary)",
                "secondary": "var(--colorChipFilledTextSecondary)",
                "success": "var(--colorChipFilledTextSuccess)",
                "warning": "var(--colorChipFilledTextWarning)"
            }
        },
        "icon": {
            "inverse": "var(--colorChipIconInverse)",
            "primary": "var(--colorChipIconPrimary)",
            "warning": "var(--colorChipIconWarning)"
        },
        "outlined": {
            "border": {
                "danger": "var(--colorChipOutlinedBorderDanger)",
                "info": "var(--colorChipOutlinedBorderInfo)",
                "primary": "var(--colorChipOutlinedBorderPrimary)",
                "secondary": "var(--colorChipOutlinedBorderSecondary)",
                "success": "var(--colorChipOutlinedBorderSuccess)",
                "warning": "var(--colorChipOutlinedBorderWarning)"
            },
            "icon": {
                "danger": "var(--colorChipOutlinedIconDanger)",
                "info": "var(--colorChipOutlinedIconInfo)",
                "primary": "var(--colorChipOutlinedIconPrimary)",
                "secondary": "var(--colorChipOutlinedIconSecondary)",
                "success": "var(--colorChipOutlinedIconSuccess)",
                "warning": "var(--colorChipOutlinedIconWarning)"
            },
            "text": {
                "danger": "var(--colorChipOutlinedTextDanger)",
                "info": "var(--colorChipOutlinedTextInfo)",
                "primary": "var(--colorChipOutlinedTextPrimary)",
                "secondary": "var(--colorChipOutlinedTextSecondary)",
                "success": "var(--colorChipOutlinedTextSuccess)",
                "warning": "var(--colorChipOutlinedTextWarning)"
            }
        },
        "text": {
            "inverse": "var(--colorChipTextInverse)",
            "primary": "var(--colorChipTextPrimary)"
        }
    },
    "codeEditor": {
        "background": "var(--colorCodeEditorBackground)",
        "code": {
            "activelineBackground": "var(--colorCodeEditorCodeActivelineBackground)",
            "atomNumberKeywordVariableAttributeQuoteColor": "var(--colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor)",
            "bracketCommentColor": "var(--colorCodeEditorCodeBracketCommentColor)",
            "cursorBorderLeft": "var(--colorCodeEditorCodeCursorBorderLeft)",
            "cursorBorderRight": "var(--colorCodeEditorCodeCursorBorderRight)",
            "defTagBuiltinQualifierHeaderEmColor": "var(--colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor)",
            "errorInvalidcharColor": "var(--colorCodeEditorCodeErrorInvalidcharColor)",
            "fatCursorBackground": "var(--colorCodeEditorCodeFatCursorBackground)",
            "hint": "var(--colorCodeEditorCodeHint)",
            "hintActiveBackground": "var(--colorCodeEditorCodeHintActiveBackground)",
            "hintsBackground": "var(--colorCodeEditorCodeHintsBackground)",
            "indentationMarker": {
                "activeColor": "var(--colorCodeEditorCodeIndentationMarkerActiveColor)",
                "color": "var(--colorCodeEditorCodeIndentationMarkerColor)"
            },
            "linenumberColor": "var(--colorCodeEditorCodeLinenumberColor)",
            "matchingbracketColor": "var(--colorCodeEditorCodeMatchingbracketColor)",
            "positiveColor": "var(--colorCodeEditorCodePositiveColor)",
            "propertyColor": "var(--colorCodeEditorCodePropertyColor)",
            "punctuationUnitNegativeColor": "var(--colorCodeEditorCodePunctuationUnitNegativeColor)",
            "selectedBackground": "var(--colorCodeEditorCodeSelectedBackground)",
            "stringOperatorColor": "var(--colorCodeEditorCodeStringOperatorColor)",
            "syntax": {
                "atom": "var(--colorCodeEditorCodeSyntaxAtom)",
                "attributeName": "var(--colorCodeEditorCodeSyntaxAttributeName)",
                "bool": "var(--colorCodeEditorCodeSyntaxBool)",
                "bracket": "var(--colorCodeEditorCodeSyntaxBracket)",
                "className": "var(--colorCodeEditorCodeSyntaxClassName)",
                "comment": "var(--colorCodeEditorCodeSyntaxComment)",
                "deleted": "var(--colorCodeEditorCodeSyntaxDeleted)",
                "deletedBackground": "var(--colorCodeEditorCodeSyntaxDeletedBackground)",
                "emphasis": "var(--colorCodeEditorCodeSyntaxEmphasis)",
                "escape": "var(--colorCodeEditorCodeSyntaxEscape)",
                "heading": "var(--colorCodeEditorCodeSyntaxHeading)",
                "invalid": "var(--colorCodeEditorCodeSyntaxInvalid)",
                "keyword": "var(--colorCodeEditorCodeSyntaxKeyword)",
                "link": "var(--colorCodeEditorCodeSyntaxLink)",
                "meta": "var(--colorCodeEditorCodeSyntaxMeta)",
                "name": "var(--colorCodeEditorCodeSyntaxName)",
                "number": "var(--colorCodeEditorCodeSyntaxNumber)",
                "operator": "var(--colorCodeEditorCodeSyntaxOperator)",
                "propertyName": "var(--colorCodeEditorCodeSyntaxPropertyName)",
                "quote": "var(--colorCodeEditorCodeSyntaxQuote)",
                "regexp": "var(--colorCodeEditorCodeSyntaxRegexp)",
                "specialVariableName": "var(--colorCodeEditorCodeSyntaxSpecialVariableName)",
                "string": "var(--colorCodeEditorCodeSyntaxString)",
                "strong": "var(--colorCodeEditorCodeSyntaxStrong)",
                "tagName": "var(--colorCodeEditorCodeSyntaxTagName)",
                "typeName": "var(--colorCodeEditorCodeSyntaxTypeName)",
                "typeOperator": "var(--colorCodeEditorCodeSyntaxTypeOperator)",
                "url": "var(--colorCodeEditorCodeSyntaxUrl)",
                "variableName": "var(--colorCodeEditorCodeSyntaxVariableName)"
            },
            "variable2Variable3String2UrlColor": "var(--colorCodeEditorCodeVariable2Variable3String2UrlColor)",
            "variableColor": "var(--colorCodeEditorCodeVariableColor)"
        },
        "foreground": "var(--colorCodeEditorForeground)",
        "selection": "var(--colorCodeEditorSelection)",
        "selectionMatch": "var(--colorCodeEditorSelectionMatch)",
        "text": {
            "default": "var(--colorCodeEditorTextDefault)",
            "gutter": "var(--colorCodeEditorTextGutter)",
            "highlight": "var(--colorCodeEditorTextHighlight)",
            "hintHighlight": "var(--colorCodeEditorTextHintHighlight)"
        },
        "toolbar": {
            "background": "var(--colorCodeEditorToolbarBackground)",
            "button": {
                "hover": "var(--colorCodeEditorToolbarButtonHover)"
            }
        }
    },
    "codeReview": {
        "background": {
            "danger": {
                "default": "var(--colorCodeReviewBackgroundDangerDefault)",
                "muted": "var(--colorCodeReviewBackgroundDangerMuted)"
            },
            "primary": {
                "default": "var(--colorCodeReviewBackgroundPrimaryDefault)",
                "muted": "var(--colorCodeReviewBackgroundPrimaryMuted)"
            },
            "success": {
                "default": "var(--colorCodeReviewBackgroundSuccessDefault)",
                "muted": "var(--colorCodeReviewBackgroundSuccessMuted)"
            }
        },
        "text": {
            "danger": "var(--colorCodeReviewTextDanger)",
            "primary": "var(--colorCodeReviewTextPrimary)",
            "success": "var(--colorCodeReviewTextSuccess)"
        }
    },
    "deprecated": {
        "background": {
            "warning": "var(--colorDeprecatedBackgroundWarning)"
        },
        "border": {
            "warning": "var(--colorDeprecatedBorderWarning)"
        },
        "icon": {
            "warning": "var(--colorDeprecatedIconWarning)"
        },
        "text": {
            "warning": "var(--colorDeprecatedTextWarning)"
        }
    },
    "dialog": {
        "background": {
            "primary": "var(--colorDialogBackgroundPrimary)",
            "secondary": {
                "default": "var(--colorDialogBackgroundSecondaryDefault)",
                "upsell": "var(--colorDialogBackgroundSecondaryUpsell)"
            }
        },
        "helpPanel": {
            "text": "var(--colorDialogHelpPanelText)"
        }
    },
    "formLegend": {
        "background": {
            "hover": "var(--colorFormLegendBackgroundHover)",
            "rest": "var(--colorFormLegendBackgroundRest)"
        }
    },
    "healthStatus": {
        "background": {
            "executing": "var(--colorHealthStatusBackgroundExecuting)",
            "failure": "var(--colorHealthStatusBackgroundFailure)",
            "neutral": "var(--colorHealthStatusBackgroundNeutral)",
            "success": "var(--colorHealthStatusBackgroundSuccess)",
            "warning": "var(--colorHealthStatusBackgroundWarning)"
        },
        "icon": {
            "default": "var(--colorHealthStatusIconDefault)",
            "inverse": "var(--colorHealthStatusIconInverse)"
        }
    },
    "icon": {
        "danger": "var(--colorIconDanger)",
        "disabled": "var(--colorIconDisabled)",
        "feature": "var(--colorIconFeature)",
        "info": "var(--colorIconInfo)",
        "inverse": {
            "primary": "var(--colorIconInversePrimary)",
            "secondary": "var(--colorIconInverseSecondary)"
        },
        "link": {
            "default": "var(--colorIconLinkDefault)",
            "hover": "var(--colorIconLinkHover)"
        },
        "primary": "var(--colorIconPrimary)",
        "secondary": "var(--colorIconSecondary)",
        "selected": "var(--colorIconSelected)",
        "success": "var(--colorIconSuccess)",
        "tertiary": "var(--colorIconTertiary)",
        "warning": "var(--colorIconWarning)"
    },
    "lifecycle": {
        "background": {
            "primary": "var(--colorLifecycleBackgroundPrimary)"
        },
        "border": {
            "default": "var(--colorLifecycleBorderDefault)"
        },
        "icon": {
            "primary": "var(--colorLifecycleIconPrimary)"
        },
        "text": {
            "primary": "var(--colorLifecycleTextPrimary)"
        }
    },
    "menuList": {
        "background": {
            "active": "var(--colorMenuListBackgroundActive)",
            "default": "var(--colorMenuListBackgroundDefault)",
            "hover": "var(--colorMenuListBackgroundHover)"
        },
        "border": {
            "primary": "var(--colorMenuListBorderPrimary)"
        },
        "icon": {
            "primary": "var(--colorMenuListIconPrimary)"
        },
        "text": {
            "highlight": "var(--colorMenuListTextHighlight)",
            "primary": "var(--colorMenuListTextPrimary)",
            "secondary": "var(--colorMenuListTextSecondary)"
        }
    },
    "navButton": {
        "background": {
            "active": "var(--colorNavButtonBackgroundActive)",
            "default": "var(--colorNavButtonBackgroundDefault)",
            "hover": "var(--colorNavButtonBackgroundHover)",
            "pressed": "var(--colorNavButtonBackgroundPressed)"
        },
        "icon": {
            "active": "var(--colorNavButtonIconActive)",
            "default": "var(--colorNavButtonIconDefault)",
            "hover": "var(--colorNavButtonIconHover)",
            "pressed": "var(--colorNavButtonIconPressed)"
        }
    },
    "navList": {
        "background": {
            "active": "var(--colorNavListBackgroundActive)",
            "default": "var(--colorNavListBackgroundDefault)",
            "hover": "var(--colorNavListBackgroundHover)"
        },
        "icon": {
            "active": "var(--colorNavListIconActive)",
            "default": "var(--colorNavListIconDefault)"
        },
        "text": {
            "active": "var(--colorNavListTextActive)",
            "default": "var(--colorNavListTextDefault)",
            "hover": "var(--colorNavListTextHover)"
        }
    },
    "navTab": {
        "background": {
            "active": "var(--colorNavTabBackgroundActive)",
            "hover": "var(--colorNavTabBackgroundHover)"
        },
        "border": {
            "primary": "var(--colorNavTabBorderPrimary)"
        },
        "icon": {
            "active": "var(--colorNavTabIconActive)",
            "default": "var(--colorNavTabIconDefault)",
            "hover": "var(--colorNavTabIconHover)"
        },
        "text": {
            "active": "var(--colorNavTabTextActive)",
            "default": "var(--colorNavTabTextDefault)",
            "hover": "var(--colorNavTabTextHover)"
        }
    },
    "overlay": {
        "primary": "var(--colorOverlayPrimary)",
        "secondary": "var(--colorOverlaySecondary)"
    },
    "pagination": {
        "background": {
            "active": "var(--colorPaginationBackgroundActive)",
            "default": "var(--colorPaginationBackgroundDefault)",
            "disabled": "var(--colorPaginationBackgroundDisabled)",
            "hover": "var(--colorPaginationBackgroundHover)"
        },
        "icon": {
            "active": "var(--colorPaginationIconActive)",
            "default": "var(--colorPaginationIconDefault)",
            "disabled": "var(--colorPaginationIconDisabled)",
            "hover": "var(--colorPaginationIconHover)"
        },
        "text": {
            "active": "var(--colorPaginationTextActive)",
            "default": "var(--colorPaginationTextDefault)",
            "disabled": "var(--colorPaginationTextDisabled)",
            "hover": "var(--colorPaginationTextHover)"
        }
    },
    "parallelChip": {
        "background": "var(--colorParallelChipBackground)",
        "icon": "var(--colorParallelChipIcon)"
    },
    "popover": {
        "background": {
            "primary": "var(--colorPopoverBackgroundPrimary)",
            "secondary": "var(--colorPopoverBackgroundSecondary)"
        },
        "infoCircle": {
            "background": {
                "default": "var(--colorPopoverInfoCircleBackgroundDefault)",
                "hover": "var(--colorPopoverInfoCircleBackgroundHover)"
            },
            "text": {
                "default": "var(--colorPopoverInfoCircleTextDefault)",
                "hover": "var(--colorPopoverInfoCircleTextHover)"
            }
        }
    },
    "portal": {
        "card": {
            "background": "var(--colorPortalCardBackground)",
            "content": {
                "disabled": "var(--colorPortalCardContentDisabled)",
                "text": "var(--colorPortalCardContentText)"
            }
        },
        "chip": {
            "background": "var(--colorPortalChipBackground)"
        },
        "link": {
            "text": {
                "hover": "var(--colorPortalLinkTextHover)"
            }
        },
        "logo": {
            "background": "var(--colorPortalLogoBackground)"
        },
        "popover": {
            "background": "var(--colorPortalPopoverBackground)"
        }
    },
    "processContainer": {
        "background": {
            "selected": "var(--colorProcessContainerBackgroundSelected)"
        },
        "border": {
            "selected": "var(--colorProcessContainerBorderSelected)"
        }
    },
    "processStep": {
        "background": {
            "error": {
                "primary": "var(--colorProcessStepBackgroundErrorPrimary)",
                "secondary": "var(--colorProcessStepBackgroundErrorSecondary)",
                "selected": "var(--colorProcessStepBackgroundErrorSelected)"
            },
            "hover": {
                "error": "var(--colorProcessStepBackgroundHoverError)",
                "primary": "var(--colorProcessStepBackgroundHoverPrimary)",
                "secondary": "var(--colorProcessStepBackgroundHoverSecondary)",
                "tertiary": "var(--colorProcessStepBackgroundHoverTertiary)",
                "warning": "var(--colorProcessStepBackgroundHoverWarning)"
            },
            "primary": {
                "default": "var(--colorProcessStepBackgroundPrimaryDefault)",
                "selected": "var(--colorProcessStepBackgroundPrimarySelected)"
            },
            "secondary": {
                "default": "var(--colorProcessStepBackgroundSecondaryDefault)"
            },
            "warning": {
                "default": "var(--colorProcessStepBackgroundWarningDefault)",
                "secondary": "var(--colorProcessStepBackgroundWarningSecondary)",
                "selected": "var(--colorProcessStepBackgroundWarningSelected)"
            }
        },
        "border": {
            "default": "var(--colorProcessStepBorderDefault)",
            "disabled": "var(--colorProcessStepBorderDisabled)",
            "error": {
                "default": "var(--colorProcessStepBorderErrorDefault)",
                "hover": "var(--colorProcessStepBorderErrorHover)",
                "selected": "var(--colorProcessStepBorderErrorSelected)"
            },
            "hover": "var(--colorProcessStepBorderHover)",
            "selected": "var(--colorProcessStepBorderSelected)",
            "warning": {
                "default": "var(--colorProcessStepBorderWarningDefault)",
                "hover": "var(--colorProcessStepBorderWarningHover)",
                "selected": "var(--colorProcessStepBorderWarningSelected)"
            }
        },
        "icon": {
            "default": "var(--colorProcessStepIconDefault)",
            "error": {
                "primary": "var(--colorProcessStepIconErrorPrimary)",
                "secondary": "var(--colorProcessStepIconErrorSecondary)"
            },
            "warning": {
                "primary": "var(--colorProcessStepIconWarningPrimary)",
                "secondary": "var(--colorProcessStepIconWarningSecondary)"
            }
        },
        "text": {
            "disabled": "var(--colorProcessStepTextDisabled)"
        }
    },
    "processWrapper": {
        "background": {
            "primary": "var(--colorProcessWrapperBackgroundPrimary)",
            "secondary": "var(--colorProcessWrapperBackgroundSecondary)"
        }
    },
    "progress": {
        "background": {
            "linear": "var(--colorProgressBackgroundLinear)",
            "primary": "var(--colorProgressBackgroundPrimary)",
            "secondary": "var(--colorProgressBackgroundSecondary)"
        },
        "foreground": {
            "circular": "var(--colorProgressForegroundCircular)",
            "linear": "var(--colorProgressForegroundLinear)"
        },
        "text": {
            "info": "var(--colorProgressTextInfo)"
        }
    },
    "scrollbar": {
        "background": "var(--colorScrollbarBackground)",
        "handle": "var(--colorScrollbarHandle)"
    },
    "spaceSwitcher": {
        "background": {
            "default": "var(--colorSpaceSwitcherBackgroundDefault)",
            "hover": "var(--colorSpaceSwitcherBackgroundHover)",
            "pressed": "var(--colorSpaceSwitcherBackgroundPressed)"
        },
        "border": {
            "primary": "var(--colorSpaceSwitcherBorderPrimary)"
        },
        "icon": {
            "default": "var(--colorSpaceSwitcherIconDefault)"
        },
        "text": {
            "default": "var(--colorSpaceSwitcherTextDefault)",
            "hover": "var(--colorSpaceSwitcherTextHover)",
            "pressed": "var(--colorSpaceSwitcherTextPressed)"
        }
    },
    "statusBadge": {
        "background": {
            "healthy": "var(--colorStatusBadgeBackgroundHealthy)",
            "neutral": "var(--colorStatusBadgeBackgroundNeutral)",
            "unhealthy": "var(--colorStatusBadgeBackgroundUnhealthy)",
            "warning": "var(--colorStatusBadgeBackgroundWarning)"
        },
        "icon": {
            "default": "var(--colorStatusBadgeIconDefault)",
            "inverse": "var(--colorStatusBadgeIconInverse)"
        },
        "text": {
            "inverse": "var(--colorStatusBadgeTextInverse)",
            "primary": "var(--colorStatusBadgeTextPrimary)"
        }
    },
    "switch": {
        "background": {
            "off": {
                "default": "var(--colorSwitchBackgroundOffDefault)",
                "disabled": "var(--colorSwitchBackgroundOffDisabled)"
            },
            "on": {
                "default": "var(--colorSwitchBackgroundOnDefault)",
                "disabled": "var(--colorSwitchBackgroundOnDisabled)"
            }
        },
        "foreground": {
            "off": {
                "default": "var(--colorSwitchForegroundOffDefault)",
                "disabled": "var(--colorSwitchForegroundOffDisabled)"
            },
            "on": {
                "default": "var(--colorSwitchForegroundOnDefault)",
                "disabled": "var(--colorSwitchForegroundOnDisabled)"
            }
        },
        "icon": {
            "active": "var(--colorSwitchIconActive)"
        },
        "overlay": {
            "off": "var(--colorSwitchOverlayOff)",
            "on": "var(--colorSwitchOverlayOn)"
        }
    },
    "table": {
        "header": {
            "background": "var(--colorTableHeaderBackground)"
        }
    },
    "tag": {
        "background": "var(--colorTagBackground)",
        "text": "var(--colorTagText)"
    },
    "text": {
        "danger": "var(--colorTextDanger)",
        "disabled": "var(--colorTextDisabled)",
        "feature": "var(--colorTextFeature)",
        "info": "var(--colorTextInfo)",
        "inverse": {
            "primary": "var(--colorTextInversePrimary)",
            "secondary": "var(--colorTextInverseSecondary)"
        },
        "link": {
            "default": "var(--colorTextLinkDefault)",
            "hover": "var(--colorTextLinkHover)"
        },
        "primary": "var(--colorTextPrimary)",
        "secondary": "var(--colorTextSecondary)",
        "selected": "var(--colorTextSelected)",
        "success": "var(--colorTextSuccess)",
        "tertiary": "var(--colorTextTertiary)",
        "warning": "var(--colorTextWarning)"
    },
    "textField": {
        "border": {
            "active": "var(--colorTextFieldBorderActive)",
            "danger": "var(--colorTextFieldBorderDanger)",
            "default": "var(--colorTextFieldBorderDefault)",
            "disabled": "var(--colorTextFieldBorderDisabled)",
            "hover": "var(--colorTextFieldBorderHover)"
        },
        "icon": {
            "disabled": "var(--colorTextFieldIconDisabled)",
            "primary": "var(--colorTextFieldIconPrimary)"
        },
        "text": {
            "danger": "var(--colorTextFieldTextDanger)",
            "disabled": "var(--colorTextFieldTextDisabled)",
            "primary": "var(--colorTextFieldTextPrimary)",
            "secondary": "var(--colorTextFieldTextSecondary)",
            "selected": "var(--colorTextFieldTextSelected)"
        }
    }
} as const;

export const shadow = {
    "drawer": "var(--shadowDrawer)",
    "extraSmall": "var(--shadowExtraSmall)",
    "focused": "var(--shadowFocused)",
    "focusedInset": "var(--shadowFocusedInset)",
    "large": "var(--shadowLarge)",
    "layoutPrimary": "var(--shadowLayoutPrimary)",
    "medium": "var(--shadowMedium)",
    "small": "var(--shadowSmall)"
} as const;